import { locales } from '@americanexpress/conditional-features';

const {
  EN_GB,
  EN_US,
  DE_DE,
  EN_AU,
  EN_NZ,
  EN_CA,
  FR_CA,
  EN_HK,
  EN_IN,
  EN_SG,
  JA_JP,
  IT_IT,
  FR_FR,
  NL_NL,
  ES_MX,
  ES_ES,
  SV_SE,
  ZH_HK,
} = locales;
export const BASE_DYNATRACE_URL = 'https://js-cdn.dynatrace.com/jstag';
export const INTL_DYNATRACE_PATH = '1623d230d17/bf44539bru';
export const TRACKING_IDS = {
  [EN_AU]: '6ca3e714188238c8',
  [EN_GB]: '9b1baa7cdd919d21',
  [EN_IN]: 'b81209712ca308c3',
  [EN_NZ]: '22137438c4b5b4e',
  [ES_MX]: 'a5cace69e1ecb230',
  [EN_CA]: 'fe4a61f62bfc9083',
  [FR_CA]: 'fe4a61f62bfc9083',
  [EN_HK]: 'ea1500e4fb017d87',
  [ZH_HK]: 'ea1500e4fb017d87',
  [JA_JP]: 'f13a03a62b88a3bb',
  [FR_FR]: '94595828c252199a',
  [DE_DE]: '75f278781dfce73',
  [EN_SG]: '285fee9847a19617',
  [IT_IT]: 'ec6d32fa1b4d667e',
  [NL_NL]: 'fd0540fabbb064c7',
  [ES_ES]: '11e504aee612e93c',
  [SV_SE]: 'b234fe607a568f6f',
  [EN_US]: '1619ed8a359/bf93265vfe/c5c47636ef19203_complete',
};
